"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { rememberedCampaignAttribution } from "@/lib/campaign-attribution";

/** Save campaign entry before the visitor navigates to a form on another page. */
export function CampaignCapture() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    rememberedCampaignAttribution(window.location.href);
  }, [pathname, searchParams]);

  return null;
}
